import styled, { css } from 'styled-components';
import TOKENS from '@nokia-csf-uxr/freeform-design-tokens';

export const MIN_HEIGHT = '168px'; // 10.5rem
export const MIN_WIDTH = '480px'; // 30rem

const FloatingPanel = styled.div`
  position: relative;
  border-radius: ${TOKENS.RADIUS.RADIUS_2};
  padding-bottom: ${TOKENS.SPACING.SPACING_24};
  min-height: ${MIN_HEIGHT};
  min-width: ${MIN_WIDTH};
  outline: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${({ $fullscreen }) => $fullscreen && css`
    padding-bottom: 0;
    [class^="styles__FloatingPanelHeaderContainer-"] {
      cursor: auto;
    }
  `}
    ${({ $rtl }) =>
    $rtl &&
    css`
      direction: rtl;
    `}
`;

const FloatingPanelHeader = styled.div`
  padding: ${TOKENS.SPACING.SPACING_16} ${TOKENS.SPACING.SPACING_24};
  flex-grow: 1;
`;
const FloatingPanelHeaderContainer = styled.div`
  cursor: move;
  display: flex;
  ${({ $divider, $theme }) =>
    $divider &&
    css`
      border-bottom: 1px solid ${$theme.divider};
    `}
`;

const FloatingPanelButtons = styled.div`
  padding-top: ${TOKENS.SPACING.SPACING_12};
  display: flex;
  ${({ $rtl }) =>
    $rtl
      ? css`
          padding-left: ${TOKENS.SPACING.SPACING_16};
        `
      : css`
          padding-right: ${TOKENS.SPACING.SPACING_16};
        `}
        > div:not(:last-child), span:not(:last-child) {
    ${({ $rtl }) =>
    $rtl
      ? css`
            margin-left: ${TOKENS.SPACING.SPACING_12};
          `
      : css`
            margin-right: ${TOKENS.SPACING.SPACING_12};
          `}
  }
`;

export default {
  FloatingPanel,
  FloatingPanelHeader,
  FloatingPanelHeaderContainer,
  FloatingPanelButtons,
};
